interface ClientWebCoreConfig {
  one: string;
}

export class ClientWebCore {
  private static $config: ClientWebCoreConfig;
  public static get config() {
    if (!this.$config) {
      throw new Error('ClientWebCore not initialized yet.');
    }
    return this.$config;
  }

  public static init(config: ClientWebCoreConfig) {
    this.$config = config;
  }
}
